module.exports = __webpack_public_path__ + "static/media/argestadisplay-regular-webfont.6e7c0fbe.ttf";